module.exports = __webpack_public_path__ + "img/lamas2.d30629e6.png";